module.exports = __webpack_public_path__ + "static/media/v1.f6e009b4.png";